<!--
  画面名：原材料・仕込み品・料理グループ分け画面
  概要： 食材を登録/編集/削除する
  備考： -
-->

<!-- HTML -->
<template>
  <div>
    <FoodData
      :pageTitle ="$language.LabelFoodGroup"
      :isPlan="true"
      :isAuth="isAuth"
    />
  </div>
</template>
<!-- /HTML -->

<script>
// 子（外部）コンポーネント読み込み
// 食材データ入力画面
import FoodData from '@/components/parts/common/FoodData'

export default {
  name: 'FoodGroup',
  // 使用コンポーネント
  components: {
    // 食材データ入力画面
    FoodData
  },
  data () {
    return {
      isAuth: true
    }
  },
  created () {
    // 権限の判定（店舗責任者）
    let auth = this.$store.getters['auth/getAuth'].auth
    if (auth === 5) {
      this.isAuth = false
    }
  }
}
</script>
